import { useQuery } from "react-query";
import { getInventoryForProduct } from "../actions/inventory.service";

export const useInventory = (handle) => {
	return useQuery([`inventory`, handle], async () => {
		return getInventoryForProduct({ handle });
	});
};
